/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPaymentDto } from '../../models/add-payment-dto';
import { TabDetailDto } from '../../models/tab-detail-dto';

export interface PosTabsControllerAddPayment$Params {
  id: string;
      body: AddPaymentDto
}

export function posTabsControllerAddPayment(http: HttpClient, rootUrl: string, params: PosTabsControllerAddPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<TabDetailDto>> {
  const rb = new RequestBuilder(rootUrl, posTabsControllerAddPayment.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TabDetailDto>;
    })
  );
}

posTabsControllerAddPayment.PATH = '/pos/tabs/{id}/payments';
